import React from 'react'
import Logo from '../../assets/img/logo.png'
function FooterComponent() {  
	const currentYear = new Date().getFullYear()

	return (
		<footer className="bg-primary py-5  text-white">
			<div className="container">
				<div className="row">
					<div className="col-sm-3  col-12"><b>Quick Links</b>
						<ul>
							<li><a target="_blank" href='https://www.mapcoparking.com/roc/parking-calculator/' className="listItems" id="bottomMenu" rel="noreferrer">ROC Airport Parking Calculator</a></li>
							<li><a target="_blank" href='https://www.mapcoparking.com/roc/parking-rewards/' className="listItems" id="bottomMenu" rel="noreferrer">ROC Airport Parking Rewards</a></li>
							<li><a target="_blank" href='https://www.mapcoparking.com/roc/zoom-lane/' className="listItems" id="bottomMenu" rel="noreferrer">ROC Airport Zoom E-Z</a></li>
							<li><a target="_blank" href='https://www.mapcoparking.com/roc/premium-parking/' className="listItems" id="bottomMenu" rel="noreferrer">ROC Airport Premium Parking</a></li>
							<li><a target="_blank" href='https://www.mapcoparking.com/ogs/parking-calculator/' className="listItems" id="bottomMenu" rel="noreferrer">OGS Airport Parking Calculator</a></li>
						</ul>
					</div>
					<div className="col-sm-3 col-12 border-end mb-sm-0 mb-5"><b className='d-none d-sm-block'>&nbsp;</b>
						<ul>

							<li><a target="_blank" href='https://www.mapcoparking.com/downtown/monthly/' className="listItems" id="bottomMenu" rel="noreferrer">Downtown Rochester Wait List</a></li>
							<li><a target="_blank" href='https://www.mapcoparking.com/downtown/where-to-park/amerks/' className="listItems" id="bottomMenu" rel="noreferrer">Rochester Americans Parking</a></li>
							<li><a target="_blank" href='https://www.mapcoparking.com/downtown/where-to-park/knighthawks/' className="listItems" id="bottomMenu" rel="noreferrer">Rochester Knighthawks Parking</a></li>
            
						</ul></div>
					<div className="col-sm-3 col-5"><b>Address</b>
						<address>
              Corporate Office <br/>488 White Spruce<br/> Blvd
                Rochester, <br/>New York 14623
						</address>
					</div>
					<div className="col-sm-3 col-6"><b>Contacts</b>
						<p> 
							<a href='mailto:parking@mapcoparking.com'>parking@mapcoparking.com
							</a><br/>
							<a href='tel:(585) 292-4900'>(585) 292-4900
							</a>
						</p>
					
            
					</div>
				</div>
			</div>
			<div className="bottomFooter">
				<div className="container d-none d-sm-block">
					<div className="row aling-items-center ">
						<div className="col-sm  ">
						Powered By: &nbsp;
							<img src={Logo} width="40px" className='opacity-50' alt="logo"/>&nbsp;
							<img className='opacity-50' src="https://parkengage.com/static/media/footer-logo.3efe0086.svg" width="120px" alt="logo"/>
							
						</div>
						<div className="col">
							<nav className="text-white">
								<a href='https://www.mapcoparking.com/about/'
									target='_blank' rel="noreferrer">About Us</a> 
								{/* <Link to={URL.HOME}>Service</Link> 
								<Link to={URL.HOME}>Procurement</Link>  */}
								<a target="_blank" href='https://www.mapcoparking.com/faq/' rel="noreferrer" >FAQ</a> 
								<a href='https://www.mapcoparking.com/contact/'
									target='_blank' rel="noreferrer">Contact Us</a> 
							</nav>
						</div>
						<div className="col-sm-3  text-end"><small>© {currentYear} MAPCO Auto Parks. All rights reserved</small>
						</div>
						
					</div>
					{/*  for mobile */}
					</div>
					<div className="container d-block d-sm-none">
					<div className="row aling-items-center ">
					<div className="col-12 order-sm order-3 mt-4 text-center ">
							Powered By: &nbsp;
							<img src={Logo} width="40px" className='opacity-50' alt="logo"/>&nbsp;
							<img  className='opacity-50' src="https://parkengage.com/static/media/footer-logo.3efe0086.svg" width="120px" alt="logo"/>
							
						
						</div>
						<div className="col-12 text-center">
							<nav className="text-white">
								<a href='https://www.mapcoparking.com/about/'
									target='_blank' rel="noreferrer">About us</a> 
								{/* <Link to={URL.HOME}>Service</Link> 
								<Link to={URL.HOME}>Procurement</Link>  */}
								<a target="_blank" href='https://www.mapcoparking.com/faq/' rel="noreferrer" >FAQ</a> 
								<a href='https://www.mapcoparking.com/contact/'
									target='_blank' rel="noreferrer">Contact Us</a> 
							</nav>
						</div>
						<div className="col-sm-3 col-12  text-center"><small> © {currentYear}. All rights reserved</small>
						</div>
						
					</div>

				</div>
			</div>
		</footer>
	)
}
export default FooterComponent
